import classNames from 'classnames';
import React, { useState } from 'react';
import * as styles from './ExtensionSearchBar.module.scss';
import Button from '../../components/Button';
import SVGIcon from '../../components/SVGIcon';
import clearIcon from '../../icons/non-prefilled/16x16/clear.svg';
import searchIcon from '../../icons/non-prefilled/16x16/search.svg';

interface ExtensionSearchBarProps {
  stuck: boolean;
  onClose: () => void;
  onSubmit: (keyword: string) => void;
}

const ExtensionSearchBar = ({
  stuck,
  onClose,
  onSubmit,
}: ExtensionSearchBarProps) => {
  const [keyword, setKeyword] = useState('');

  return (
    <form
      className={classNames(styles.container, { [styles.stuck]: stuck })}
      onSubmit={(e) => {
        onSubmit(keyword);
        e.preventDefault();
      }}
    >
      <input
        type="text"
        name="keyword"
        value={keyword}
        placeholder="Search for knowledge"
        onChange={(e) => {
          const newKeyword = e.target.value;
          setKeyword(newKeyword);
          if (!newKeyword) {
            onSubmit('');
          }
        }}
        aria-label="Search input"
      />
      <SVGIcon className={styles.icon}>{searchIcon}</SVGIcon>
      <div className={styles.clearButtonContainer}>
        <Button
          className={styles.clearButton}
          onClick={onClose}
          icon={clearIcon}
          aria-label="Close Slab"
        />
      </div>
    </form>
  );
};

export default ExtensionSearchBar;
